import { render, staticRenderFns } from "./PayCoin.vue?vue&type=template&id=f2b25d80&"
import script from "./PayCoin.vue?vue&type=script&lang=ts&"
export * from "./PayCoin.vue?vue&type=script&lang=ts&"
import style0 from "./PayCoin.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports